import React from 'react';
import { Container, Typography, Link } from '@mui/material';

export default function Support() {
  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Support
      </Typography>
      <Typography variant="body1">
        For any issues or enquiries please email us at{' '}
        <Link href="mailto:support@thinkode.co.uk">
          support@thinkode.co.uk
        </Link>.
      </Typography>
    </Container>
  );
}
